import React, { createContext, useState, useEffect} from "react";
import Swal from "sweetalert2";
import caAPI from "../services/caAPI";
import { trackPromise } from "react-promise-tracker";

export const MeioComunicacaoContext = createContext({});

export function MeioComunicacaoProvider({ children }) {
  const [meiosComunicacao, setMeiosComunicacao] = useState([]);
  const [contatoOrigemSelecionado, setContatoOrigemSelecionado] = useState(null);
  const [mapaMeioComunicacao, setMapaMeioComunicao] = useState(new Map());

  useEffect(()=>{
    const novoMapa = new Map();
    meiosComunicacao.forEach((meioComunicacao) => {
      novoMapa.set(Number(meioComunicacao.id), meioComunicacao);
    });
    setMapaMeioComunicao(novoMapa);
  }, [meiosComunicacao]);

  const recarregarMeiosComunicacao = ()=>{
    trackPromise(caAPI.meio_comunicacao.list().then(res => {
        setMeiosComunicacao(res.data);
    }).catch(err => Swal.fire({
        titleText: "Erro",
        text: "Houve um problema ao buscar os meios de comunicação  " + err,
        icon: 'error'
    })), 'loading-meio-comunicacao')
  };

  const resolverNomeMeioComunicacao = (idMeioComunicacao, padrao = "Não Atribuído") => {
    let meioComunicacao = mapaMeioComunicacao.get(Number(idMeioComunicacao));
    return (meioComunicacao && meioComunicacao.nome) || padrao;
  };

  const resolverSlugMeioComunicacao = (idMeioComunicacao, padrao = "Não Atribuído") => {
    let meioComunicacao = mapaMeioComunicacao.get(Number(idMeioComunicacao));
    return (meioComunicacao && meioComunicacao.slug) || padrao;
  };

  return (
    <MeioComunicacaoContext.Provider value={{
      meiosComunicacao,
      recarregarMeiosComunicacao,
      resolverNomeMeioComunicacao,
      resolverSlugMeioComunicacao,
      setMeiosComunicacao,
      contatoOrigemSelecionado, 
      setContatoOrigemSelecionado
    }}>
      {children}
    </MeioComunicacaoContext.Provider>
  )
}
